import React, {FC, useState} from "react"
import {Card, Col, Container, Form, Row, Table} from "react-bootstrap"
import {useTranslation} from "react-i18next"
import {useAuth} from "../../context/AuthProvider"
import axios from "axios"

type SettingsComponentProps = Record<string, unknown>

const SettingsComponent: FC<SettingsComponentProps> = () => {
    const {t, i18n} = useTranslation("settings")

    const auth = useAuth()

    const [settings, setSettings] = useState<any>(null)
    const [changed, setChanged] = useState<Boolean>(false)

    React.useEffect(() => {
        axios.get("/api/user/profile/settings", auth.axiosAuthHeader()).then((response) => {
            setSettings(response.data)
        })
    }, [])

    React.useEffect(() => {
        if (changed) {
            axios.post("/api/user/profile/settings", settings, auth.axiosAuthHeader()).then((response) => {
                setChanged(false)
            })
            setChanged(false)
        }
    }, [settings])

    const changeMailSettingStudent = () => {
        setSettings((settings: any) => ({...settings, emailNotificationStudent: !settings.emailNotificationStudent}))
        setChanged(true)
    }
    return (<div className="component">
        <Container>
            <Row>
                <Col>
                    <Card>
                        <Card.Header><h3>{t("user.settings.title")}</h3></Card.Header>
                        <Card.Body>
                            {settings ? <Form><Table striped bordered hover size="sm">
                                <thead>
                                <tr>
                                    <th><h3>{t("user.settings.key")}</h3></th>
                                    <th><h3>{t("user.settings.value")}</h3></th>
                                    <th><h3>{t("user.settings.origin")}</h3></th>
                                    <th><h3>{t("user.settings.purpose")}</h3></th>
                                    <th><h3>{t("user.settings.settings")}</h3></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{t("user.settings.key.language")}</td>
                                    <td>{i18n.language}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.own')}</td>
                                    <td>{t("user.settings.key.language.purpose")}</td>
                                    <td className="text-end text-muted small">{t('user.settings.setting.changeNavbar')}</td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.title")}</td>
                                    <td>{settings.title}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.title.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.givenName")}</td>
                                    <td>{settings.given_name}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.givenName.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.familyName")}</td>
                                    <td>{settings.family_name}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.familyName.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>ESI</td>
                                    <td>{settings.esi}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.esi.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.email")}</td>
                                    <td>{settings.email}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.email.purpose")}</td>
                                    <td><Form.Check
                                        type="switch"
                                        id="custom-switch1"
                                        label={t('user.settings.setting.email.notification')}
                                        checked={settings.emailNotificationStudent}
                                        onClick={() => changeMailSettingStudent()}
                                    /></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.preferredKeyboardLayout")}</td>
                                    <td>{settings.preferredKeyboardLayout}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.own')}</td>
                                    <td>{t("user.settings.key.preferredKeyboardLayout.purpose")}</td>
                                    <td className="text-end text-muted small">{t('user.settings.setting.changeByBooking')}</td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.prefersMouseRight")}</td>
                                    <td>{settings.prefersMouseLeft ? t('user.settings.value.prefersMouseRight.left') : t("user.settings.value.prefersMouseRight.right")}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.own')}</td>
                                    <td>{t("user.settings.key.prefersMouseRight.purpose")}</td>
                                    <td className="text-end text-muted small">{t('user.settings.setting.changeByBooking')}</td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.primaryMouseButton")}</td>
                                    <td>{t('user.settings.value.primaryMouseButton')}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.own')}</td>
                                    <td>{t("user.settings.key.primaryMouseButton.purpose")}</td>
                                    <td className="text-end text-muted small">{t('user.settings.setting.notSupported')}</td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.preferred_username")}</td>
                                    <td>{settings.preferred_username}</td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.preferred_username.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.affiliations")}</td>
                                    <td>
                                        <ul>{settings.eduPersonScopedAffiliation.map((aff: any) => <li>{aff}</li>)}</ul>
                                    </td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.affiliations.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.ou")}</td>
                                    <td>
                                        <ul>{settings.ou.map((ou: any) => <li>{ou}</li>)}</ul>
                                    </td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.ou.purpose")}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{t("user.settings.key.voPersonAffiliation")}</td>
                                    <td>
                                        <ul>{settings.voPersonAffiliation ? settings.voPersonAffiliation.map((voPersonAffiliation: any) =>
                                            <li>{voPersonAffiliation}</li>) : null}</ul>
                                    </td>
                                    <td className="text-end text-muted small">{t('user.settings.origin.byIDM')}</td>
                                    <td>{t("user.settings.key.voPersonAffiliation.purpose")}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </Table></Form> : null}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)
}

export default SettingsComponent